import React, { useState } from 'react';
import Footer from "../views/Footer";
import FadeIn from "../components/FadeIn";
import PlacementOpportunities from "../components/PlacementOpportunities";
import EnquiryForm from "../components/EnquiryForm";
import LeadCaptureModal from "../components/LeadCaptureModal";

const Placement = () => {
  const [showLeadModal, setShowLeadModal] = useState(false);
  const [selectedCourse, setSelectedCourse] = useState(null);

  const handleEnrollNow = () => {
    setShowLeadModal(true);
  };

  const closeLeadModal = () => {
    setShowLeadModal(false);
    setSelectedCourse(null);
  };

  const faqs = [
    { q: "What is the duration of the placement assistance?", a: "We provide placement assistance until you get placed in a reputed company. Our support starts right from your training phase." },
    { q: "Do you offer online or offline training?", a: "We offer both online and offline training modes. You can choose the one that suits your schedule and location best." },
    { q: "Are there any internship opportunities?", a: "Yes, we provide internship opportunities with our partner companies to give you real-world project experience." },
    { q: "What kind of companies hire from BIM Bytes Academy?", a: "Our students are placed in leading AEC firms, BIM consultancies, and construction companies both in India and abroad." }
  ];

  const testimonials = [
    { name: "Arun Kumar", quote: "The practical training at BIM Bytes Academy helped me secure a BIM Modeler role within 2 months of finishing the course.", img: require('../assets/group.jpeg') },
    { name: "Priya S.", quote: "The trainers are industry experts. Their guidance on real projects was invaluable for my career growth.", img: require('../assets/group.jpeg') },
    { name: "Rahul V.", quote: "Best institute for Revit MEP. The placement support team is very dedicated and helpful.", img: require('../assets/group.jpeg') },
    { name: "Sneha R.", quote: "I joined as a beginner and now I am confident in handling complex BIM coordination tasks.", img: require('../assets/group.jpeg') }
  ];

  return (
    <>
      {/* Student Work / Projects Section */}
      <section className="bg-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <FadeIn delay={0.2} direction="down" fullWidth>
            <div className="text-center mb-16">
              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-textPrimary mb-4">
                Student <span className="text-gradient">Work & Projects</span>
              </h2>
              <p className="text-lg text-textSecondary max-w-3xl mx-auto">
                Visual proof of the skills our students develop during their training
              </p>
            </div>
          </FadeIn>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              { id: 1, img: require('../assets/IMG_2270.jpg') },
              { id: 2, img: require('../assets/IMG_2258.jpg') },
              { id: 3, img: require('../assets/IMG_2267.jpg') }
            ].map((project, index) => (
              <FadeIn key={project.id} delay={0.1 * index} direction="up">
                <div className="rounded-2xl overflow-hidden shadow-lg aspect-video bg-gray-100 ring-1 ring-primary/10">
                  <img src={project.img} alt={`Student Project ${project.id}`} className="w-full h-full object-cover" />
                </div>
              </FadeIn>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      {/* Testimonials Section */}
      <section className="bg-gray-50 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

          <FadeIn delay={0.2} direction="down" fullWidth>
            <div className="text-center mb-16">
              <p className="text-primary font-semibold uppercase tracking-wider mb-3">
                What Our Students Say
              </p>

              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-textPrimary">
                Voices of Our <span className="text-gradient">Achievers</span>
              </h2>
            </div>
          </FadeIn>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {testimonials.map((t, idx) => (
              <FadeIn key={idx} delay={0.1 * idx} direction="up">
                <div className="bg-white rounded-2xl border border-border shadow-sm hover:shadow-lg transition-all duration-300 p-8 h-full flex flex-col justify-between">

                  {/* Quote Icon */}
                  <div className="text-5xl text-primary leading-none mb-6">
                    “
                  </div>

                  {/* Quote */}
                  <p className="text-textSecondary leading-relaxed mb-8">
                    {t.quote}
                  </p>

                  {/* Stars */}
                  <div className="flex gap-1 text-yellow-400 text-lg">
                    ⭐ ⭐ ⭐ ⭐ ⭐
                  </div>

                </div>
              </FadeIn>
            ))}
          </div>
        </div>
      </section>

      {/* Course Mode & Module Info */}
      <section className="bg-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            <FadeIn delay={0.2} direction="left">
              <div>
                <h2 className="text-3xl font-bold text-textPrimary mb-6">Flexible <span className="text-primary">Course Modules</span></h2>
                <div className="space-y-6">
                  <div className="flex gap-4">
                    <div className="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center shrink-0">
                      <span className="text-2xl">💻</span>
                    </div>
                    <div>
                      <h3 className="text-xl font-bold text-textPrimary">Online Mode</h3>
                      <p className="text-textSecondary">Learn from the comfort of your home with our interactive live online sessions and recorded lectures.</p>
                    </div>
                  </div>
                  <div className="flex gap-4">
                    <div className="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center shrink-0">
                      <span className="text-2xl">🏢</span>
                    </div>
                    <div>
                      <h3 className="text-xl font-bold text-textPrimary">Offline Mode</h3>
                      <p className="text-textSecondary">Join our state-of-the-art academy in Chennai for hands-on classroom training and face-to-face mentorship.</p>
                    </div>
                  </div>
                </div>
              </div>
            </FadeIn>
            <FadeIn delay={0.2} direction="right">
              <div className="bg-crimson rounded-3xl p-8 text-white">
                <h3 className="text-2xl font-bold mb-4">Start your learning journey today!</h3>
                <p className="mb-6 opacity-90">Unlock opportunities in the global BIM industry with our expert-led training programs.</p>
                <button 
                  className="btn-white w-full py-4 text-lg font-bold cursor-pointer hover:bg-gray-100 transition-colors"
                  onClick={handleEnrollNow}
                >
                  Apply for Admission
                </button>
              </div>
            </FadeIn>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="bg-gray-50 py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <FadeIn delay={0.2} direction="down" fullWidth>
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold text-textPrimary mb-4">Frequently Asked <span className="text-primary">Questions</span></h2>
            </div>
          </FadeIn>
          <div className="space-y-4">
            {faqs.map((faq, idx) => (
              <FadeIn key={idx} delay={0.1 * idx} direction="up">
                <details className="group bg-white rounded-xl border border-border overflow-hidden">
                  <summary className="flex items-center justify-between p-6 cursor-pointer list-none">
                    <h3 className="text-lg font-bold text-textPrimary">{faq.q}</h3>
                    <span className="transition-transform group-open:rotate-180">▼</span>
                  </summary>
                  <div className="px-6 pb-6 text-textSecondary leading-relaxed">
                    {faq.a}
                  </div>
                </details>
              </FadeIn>
            ))}
          </div>
        </div>
      </section>

      {/* Placement Opportunities */}
      <section className="bg-gray-50 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <FadeIn delay={0.2} direction="down" fullWidth>
            <div className="text-center mb-16">
              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-textPrimary mb-4">
                <span className="text-gradient">Current Opportunities</span>
              </h2>
              <p className="text-lg text-textSecondary max-w-3xl mx-auto">
                Explore available placement and internship positions from our partner companies
              </p>
            </div>
          </FadeIn>

          <PlacementOpportunities />
        </div>
      </section>

      {/* Enquiry Form */}
      <section className="bg-white py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <FadeIn delay={0.2} direction="up" fullWidth>
            <EnquiryForm />
          </FadeIn>
        </div>
      </section>
      {/* Final CTA Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

          <div className="relative overflow-hidden rounded-3xl bg-gradient-to-r from-[#7f0d0d] to-[#b91c1c] p-10 lg:p-14 shadow-2xl">

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">

              {/* Left Content */}
              <div>
                <h2 className="text-4xl lg:text-5xl font-bold text-white leading-tight mb-6">
                  Start Your Learning <br />
                  Journey <span className="text-yellow-300">Today!</span>
                </h2>

                <p className="text-white/90 text-lg mb-8 max-w-xl leading-relaxed">
                  Join thousands of successful BIM professionals and build your future with expert-led training programs and real-world project experience.
                </p>

                <div className="flex flex-wrap gap-6 text-white">
                  <div className="flex items-center gap-2">
                    <span className="text-xl">🎓</span>
                    <span>Expert Training</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <span className="text-xl">📂</span>
                    <span>Real Projects</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <span className="text-xl">💼</span>
                    <span>Placement Support</span>
                  </div>
                </div>
              </div>

              {/* Right Side */}
              <div className="flex flex-col items-center lg:items-end gap-6">
                <button
                  onClick={handleEnrollNow}
                  className="bg-white hover:bg-gray-100 text-primary  transition-all duration-300 px-10 py-5 rounded-2xl text-lg font-bold shadow-xl inline-block"
                >
                  ENROLL NOW →
                </button>
                <p className="text-white/90 text-sm">
                  Your dream career is just a click away!
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />

      {/* Lead Capture Modal */}
      <LeadCaptureModal
        isOpen={showLeadModal}
        onClose={closeLeadModal}
        selectedCourse={selectedCourse}
      />
    </>
  );
};

export default Placement;
